"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconSize = exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _coreMixins = require("@vfuk/core-mixins");
function getIconSizeFromThemeAndGroup(theme, group, size) {
  var iconProperties = theme.getIconProperties(group);
  if (!size) return iconProperties.size[iconProperties.defaultSize];
  return iconProperties.size[size] || iconProperties.size[iconProperties.defaultSize];
}
function checkIconWidthOverride(theme, group) {
  var iconProperties = theme.getIconProperties(group);
  if (iconProperties.widthOverride) return iconProperties.widthOverride;
  return undefined;
}
var getIconSize = (0, _coreMixins.createMixin)(function (theme, isResponsive, iconSize, iconWidthOverride) {
  if (!isResponsive) {
    return (0, _styledComponents.css)(["width:", ";height:", "px;"], iconWidthOverride || "".concat(iconSize.xl, "px"), iconSize.xl);
  }
  return (0, _styledComponents.css)(["width:", ";height:", "px;", " ", " ", ""], iconWidthOverride || "".concat(iconSize.sm, "px"), iconSize.sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["width:", ";height:", "px;"], iconWidthOverride || "".concat(iconSize.md, "px"), iconSize.md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["width:", ";height:", "px;"], iconWidthOverride || "".concat(iconSize.lg, "px"), iconSize.lg)), _coreMixins.respondTo.xl((0, _styledComponents.css)(["width:", ";height:", "px;"], iconWidthOverride || "".concat(iconSize.xl, "px"), iconSize.xl)));
});
exports.getIconSize = getIconSize;
var _default = (0, _coreMixins.createMixin)(function (theme, size, isResponsive, group) {
  var iconSize = getIconSizeFromThemeAndGroup(theme, group, size);
  var iconWidthOverride = checkIconWidthOverride(theme, group);
  return (0, _styledComponents.css)(["", ""], getIconSize(isResponsive, iconSize, iconWidthOverride));
});
exports["default"] = _default;
//# sourceMappingURL=iconSizes.js.map